<template>
  <div>token刷新{{token}}</div>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return{
      token:""
    }
  },
  mounted(){
    let token = this.getQueryString('token')
    localStorage.setItem('token',token)
    if(token){
      axios.defaults.headers.common["token"] = JSON.parse(token).token;
    }

    console.log(this.token,axios.defaults.headers.common["token"])
  },
  methods:{
    getQueryString(name){
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
      var r = window.location.search.substr(1).match(reg); 
      if (r != null) return unescape(r[2]); 
      return null; 
    }
  }
}
</script>

<style>

</style>